import { HttpClient } from '@angular/common/http';
import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  HostListener,
  OnInit,
  ViewChild,
} from '@angular/core';
import { Router } from '@angular/router';
import { HelperService } from '../../services/helper/helper.service';
import { UiService } from '../../services/ui/ui.service';
import { UserService } from '../../services/user/user.service';

declare var $;

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.css'],
})
export class SidebarComponent implements OnInit, AfterViewInit {
  @ViewChild('myStudiesNav') public myStudiesNav: ElementRef;
  @ViewChild('assignmentNav') public assignmentNav: ElementRef;
  @ViewChild('contactsNav') public contactsNav: ElementRef;
  @ViewChild('coursesNav') public coursesNav: ElementRef;
  @ViewChild('createCourseNav') public createCourseNav: ElementRef;
  @ViewChild('assessmentNav') public assessmentNav: ElementRef;

  public baseRoute: string;
  public nextClassName: any;
  public unreadcount;
  public previousClass: string = '';
  public rolePermission: string;
  public showNavs = {
    myStudies: false,
    assignment: false,
    contacts: false,
    courses: false,
    createCourse: false,
    assessment: false,
  };
  public scrollbarOptions = {
    axis: 'y',
    theme: 'minimal',
    autoExpandScrollbar: true,
    // scrollbarPosition: 'outside',
    scrollInertia: 200,
    mouseWheel: { preventDefault: true },
  };
  public newBadge = null;

  constructor(
    public ui: UiService,
    public user: UserService,
    public helper: HelperService,
    private router: Router,
    private cd: ChangeDetectorRef,
    private http: HttpClient
  ) { }

  ngOnInit() {
    this.rolePermission = localStorage.getItem('Guest');
    this.checkWindowSize();

    this.getUnreadCount();
    this.getNewBadges();
    if (this.user.role !== 'exchange') {
      this.http.get('/contact/show/my-class-name').subscribe(
        (res: any) => {
          if (
            !this.helper.hideStudentOfClasses.includes(res.prev_english) &&
            res.prev_class != 'NA'
          ) {
            this.previousClass = res.prev_class;
          }
        },
        (err) => { }
      );

      this.http.get('/contact/show/my-class-next').subscribe(
        (res: any) => {
          this.nextClassName = 0;
          if (
            res.next_class != null ||
            res.next_class != '' ||
            res.next_class != 'null'
          ) {
            this.nextClassName = res.next_class;
            localStorage.setItem(
              'nextClassData',
              JSON.stringify({
                ...res.data,
                data:
                  res.data &&
                  res.data.data &&
                  res.data.data.map((data) => data.emba_user),
              })
            );
          }
        },
        (err) => { }
      );
    }
    /* this.http.get( + "users/").subscribe((data: any) => {
      if (data.result.length > 0) {
        this.show = true;
        this.form = false;
        this.userList = data.result;
      }
    }); */
  }

  ngAfterViewInit() {
    // setTimeout(() => {
    //   const checkNavOpenFn = (showNavsKey, element) => {
    //     const classList = element && element.nativeElement.classList;
    //     this.showNavs[showNavsKey] = (classList && classList.contains('show-child-nav')) || false;
    //   }

    //   const navElems = {
    //     myStudies: this.myStudiesNav,
    //     assignment: this.assignmentNav,
    //     contacts: this.contactsNav,
    //     courses: this.coursesNav,
    //     createCourse: this.createCourseNav,
    //     assessment: this.assessmentNav
    //   };

    //   Object.entries(navElems).forEach(item => checkNavOpenFn(item[0], item[1]));
    // }, 0);
    const navClick = $('.js-show-child-nav');
    const showChildNav = $('.js-open-nav');

    $(navClick).on('click', function (e) {
      e.preventDefault();
      // slideup siblings nav child menu if any open
      $(this).parent().siblings().find(showChildNav).slideUp(200);
      $(this).parent().siblings().find(navClick).removeClass('nav-open');
      // add class and slide down nav child menu when clicked
      $(this).toggleClass('nav-open');
      $(this).siblings(showChildNav).slideToggle(200);
    });
  }

  @HostListener('window:resize')
  onWindowResize() {
    this.checkWindowSize();
  }

  private checkWindowSize() {
    this.ui.showSidebar = window.innerWidth >= 991;
  }

  getUnreadCount() {
    this.http.get('/message/unread-count').subscribe(
      (res: any) => {
        this.ui.unreadCount = res;
        //this.unreadcount = this.ui.unreadCount;
        //localStorage.setItem("unreadCount", res);
      },
      (err) => { }
    );
  }

  getNewBadges() {
    this.http.get('/bmi-notification/new-badge').subscribe(
      (res: any) => {
        this.newBadge = res;
      },
      (err) => { }
    );
  }

  removeNewBadge(key) {
    if (this.newBadge && this.newBadge[key]) {
      this.newBadge[key] = 0;
    }
  }

  toggle(key) {
    Object.keys(this.showNavs).forEach((K) => {
      this.showNavs[K] = K === key ? !this.showNavs[K] : false;
    });
  }
}



// WEBPACK FOOTER //
// G:/UTL/Student/Student-ANG/src/app/shared/sidebar/sidebar.component.ts